function HeroGlow() {
  return (
    <div className="axi-hero-glow" aria-hidden="true">
      <svg
        className="axi-hero-glow__svg"
        viewBox="0 0 1400 320"
        preserveAspectRatio="xMaxYMid slice"
      >
        <defs>
          <linearGradient id="gold-flow" x1="1" y1="0.25" x2="0.1" y2="0.65">
            <stop offset="0%" stopColor="#F0CB6E" stopOpacity="0.98" />
            <stop offset="22%" stopColor="#E5B94A" stopOpacity="0.92" />
            <stop offset="55%" stopColor="#D6A23A" stopOpacity="0.65" />
            <stop offset="100%" stopColor="#E5B94A" stopOpacity="0" />
          </linearGradient>

          {/* Heavy blur for soft premium glow base */}
          <filter id="glow-heavy" x="-120%" y="-120%" width="340%" height="340%">
            <feGaussianBlur in="SourceGraphic" stdDeviation="26" />
          </filter>
          <filter id="glow-medium" x="-60%" y="-60%" width="220%" height="220%">
            <feGaussianBlur in="SourceGraphic" stdDeviation="9" />
          </filter>
        </defs>

        {/* Very wide soft base halo - the "light volume" that makes it feel integrated (not pasted) */}
        <path
          className="hero-halo"
          d="M 60 105 Q 380 175 620 95 Q 880 145 1180 55"
          fill="none"
          stroke="url(#gold-flow)"
          strokeWidth="210"
          strokeLinecap="round"
          opacity="0.18"
          filter="url(#glow-heavy)"
        />

        {/* Main elegant curved ribbon - matches reference's flowing arc */}
        <path
          className="hero-ribbon"
          d="M 95 88 Q 360 158 610 92 Q 860 138 1120 48"
          fill="none"
          stroke="url(#gold-flow)"
          strokeWidth="8.5"
          strokeLinecap="round"
          opacity="0.88"
        />

        {/* Upper highlight stroke for depth and premium edge */}
        <path
          className="hero-ribbon hero-ribbon--highlight"
          d="M 70 72 Q 340 138 595 78 Q 845 120 1095 35"
          fill="none"
          stroke="#F5D78A"
          strokeWidth="2.5"
          strokeLinecap="round"
          opacity="0.72"
        />

        {/* Lower parallel stroke for ribbon volume */}
        <path
          className="hero-ribbon hero-ribbon--echo"
          d="M 115 102 Q 375 168 625 108 Q 875 152 1135 62"
          fill="none"
          stroke="#C99A3A"
          strokeWidth="2"
          strokeLinecap="round"
          opacity="0.48"
        />

        {/* Soft mid layer for smooth blend */}
        <path
          className="hero-volume"
          d="M 80 98 Q 350 165 605 100 Q 855 148 1110 55"
          fill="none"
          stroke="url(#gold-flow)"
          strokeWidth="95"
          strokeLinecap="round"
          opacity="0.12"
          filter="url(#glow-medium)"
        />
      </svg>
    </div>
  );
}

export default HeroGlow;